
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getTotalCount: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/magicBean/getTotalCount`,
				method: 'get'
			},
			getSignRecord: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/magicBean/getSignRecord?`,
				method: 'get'
			},
			sign: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/magicBean/sign?obtainCount=${data.obtainCount}&signDate=${data.signDate}`,
				method: 'post'
			},
			exchangeRecord: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/magicBean/exchangeRecord?pageIndex=${data.page}&pageSize=${data.size}`,
				method: 'get'
			},
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"signInPage"
			})
		}